export type NewsCategory = 'Events' | 'Announcements' | 'Insights';
export const newsCategories = ['All', 'Events', 'Announcements', 'Insights'] as const;
export type FilterCategory = (typeof newsCategories)[number];

export interface NewsItem {
    slug: string;
    title: string;
    date: string;
    cover: string;
    category: NewsCategory;
    isExternal?: boolean;
    description?: string;
}

export const newsList: NewsItem[] = [
    {
        slug: 'hopeai-workspace-enables-lean-biotech-development',
        title: 'HopeAI Workspace Enables Lean Biotech Development',
        date: '2026-10',
        cover: '/img/news/biotechx_2026_cover.png',
        category: 'Events',
        isExternal: false,
        description: 'HopeAI demonstrated its Workspace for Drug Development and shared how evidence-grounded AI helped a lean Japanese biotech build a credible path toward a global Phase 3 study.'
    },
    {
        slug: 'hopeai-presents-sold-out-short-course-at-the-2026-risw',
        title: 'HopeAI Presents Sold-Out Short Course at the 2026 RISW',
        date: '2026-09',
        cover: '/img/news/risw_2026_cover.png',
        category: 'Events',
        isExternal: false,
        description: 'More than 100 attendees joined HopeAI for a three-hour program connecting advances in adaptive trial design with the practical use of AI in clinical development.'
    },
    {
        slug: 'hopeai-unveils-its-ai-native-workspace-for-drug-development-at-risw-2026',
        title: 'HopeAI Unveils Its AI-Native Workspace for Drug Development at RISW 2026',
        date: '2026-09',
        cover: '/img/news/workspace_launch_cover.png',
        category: 'Announcements',
        isExternal: false,
        description: 'HopeAI Workspace unifies specialized AI agents, validated workflows, and human oversight across six drug development functions.'
    },
    {
        slug: 'beyond-ai-experimentation-biostatisticians-are-putting-ai-to-work',
        title: 'Beyond AI Experimentation Biostatisticians Are Putting AI to Work',
        date: '2026-09',
        cover: '/img/news/beyond_ai_experimentation_cover.png',
        category: 'Insights',
        isExternal: false,
        description: 'A pre-course survey at RISW finds that AI is already part of everyday work—while reliability, privacy, and governance remain the biggest barriers to broader use.'
    },
    {
        slug: 'hopeai-introduces-a-unified-ai-workspace-at-dia-2026',
        title: 'HopeAI Introduces a Unified AI Workspace at DIA 2026',
        date: '2026-09',
        cover: '/img/news/dia_2026_cover.png',
        category: 'Events',
        isExternal: false,
        description: 'Beyond point tools: HopeAI presented a unified workspace vision bringing specialized AI capabilities and evidence-based clinical trial design into one trusted platform.'
    },
    {
        slug: 'asco-2026-chicago',
        title: 'From Trial Design and Development to Regulatory Success',
        date: '2026-05',
        cover: '/img/news/ASCO_2026_Chicago.jpg',
        category: 'Events',
        isExternal: false,
        description: 'Connecting trial design, synthetic controls, and regulatory precedents to accelerate clinical programs.'
    },
    {
        slug: 'https://www.yicaiglobal.com/news/opinion-playbook-for-ai-in-clinical-trial-design-in-2026',
        title: 'Published in YiCai Global: Playbook for AI in Clinical Trial Design',
        date: '2026-04',
        cover: '/img/news/yicai_04.jpg',
        category: 'Insights',
        isExternal: true,
        description: 'An expert perspective on how AI and adaptive methodology are transforming modern clinical trial design.'
    },
    {
        slug: 'asa_nj_webinar_series',
        title: 'The Next Chapter of Biometrics: AI and Regulatory Readiness',
        date: '2026-03',
        cover: '/img/news/asa_nj.jpg',
        category: 'Events',
        isExternal: false,
        description: 'HopeAI joins biostatistical leaders to discuss regulatory expectations for AI in clinical evidence.'
    },
    {
        slug: 'https://www.yicaiglobal.com/news/opinion-2026-the-dawn-of-ai-driven-drug-development',
        title: 'Published in YiCai Global & Bloomberg Terminal',
        date: '2026-01',
        cover: '/img/news/YiCai02.jpg',
        category: 'Insights',
        isExternal: true,
        description: 'A deep dive into 2026 drug development trends and the critical role of AI-native platforms.'
    },
    {
        slug: 'hopeai_to_host_innovation_summit_at_jpm_2026',
        title: 'HopeAI to Host Innovation Summit at JPM 2026',
        date: '2026-01',
        cover: '/img/jpmorgan.png',
        category: 'Events',
        isExternal: false,
        description: 'Bringing together biopharma executives and clinical development leaders during J.P. Morgan Healthcare Conference.'
    },
    {
        slug: 'hopeai-2025-milestones',
        title: 'HopeAI Closes 2025 with Accelerating Momentum, Moving Biopharma from AI Pilots to Adoption in Workflows',
        date: '2025-12',
        cover: '/img/news/2025-milestones.jpg',
        category: 'Announcements',
        isExternal: false,
        description: 'A retrospective on milestones achieved across clinical evidence, synthetic control arms, and workflow adoption.'
    },
    {
        slug: 'how-hopeai-and-dr-tanja-obradovic-are-using-ai-to-redefine-clinical-trial-decision-making',
        title: 'How HopeAI and Dr. Tanja Obradovic Are Using AI to Redefine Clinical Trial Decision-Making',
        date: '2025-11',
        cover: '/img/new07.png',
        category: 'Insights',
        isExternal: false,
        description: 'Why decision-making — not paperwork and process — determines speed, cost, and patient impact in drug development.'
    },
    {
        slug: 'new-advisor-announcement',
        title: 'New Advisor Announcement',
        date: '2025-11',
        cover: '/img/new06.png',
        category: 'Announcements',
        isExternal: false,
        description: 'Welcoming distinguished industry leaders to the HopeAI strategic advisory board.'
    },
    {
        slug: 'hopeai-joins-johnson-johnson-innovation-jlabs-nyc-to-advance-ai-powered-clinical-development',
        title: 'HopeAI Joins Johnson & Johnson Innovation – JLABS @ NYC to Advance AI-Powered Clinical Development',
        date: '2025-07',
        cover: '/img/news04.jpg',
        category: 'Announcements',
        isExternal: false,
        description: 'HopeAI selected to join JLABS @ NYC, expanding collaboration with life science innovators.'
    },
    {
        slug: 'HopeAI-Showcases-AI-Powered-Synthetic-Data-to-Speed-Up-Cancer-Drug-Trials-at-ASCO-2025',
        title: 'HopeAI Showcases AI-Powered Synthetic Data to Speed Up Cancer Drug Trials at ASCO 2025',
        date: '2025-06',
        cover: '/img/news01.jpg',
        category: 'Events',
        isExternal: false,
        description: 'Presenting research demonstrating synthetic patient data applications in oncology trial design.'
    },
    {
        slug: 'https://www.debiopharm.com/innovation-fund/press-releases/debiopharm-innovation-fund-welcomes-hope-ai-to-their-portfolio',
        title: 'Debiopharm Innovation Fund Welcomes HopeAI to Their Portfolio',
        date: '2025-01',
        cover: '/img/news05.png',
        category: 'Announcements',
        isExternal: true,
        description: 'Debiopharm Innovation Fund backs HopeAI in advancing AI for clinical development.'
    },
    {
        slug: 'HopeAI-Joins-Mayo-Clinic-Platform-to-Transform-the-Future-of-Drug-Development-with-AI',
        title: 'HopeAI Joins Mayo Clinic Platform to Transform the Future of Drug Development with AI',
        date: '2024-12',
        cover: '/img/news02.jpg',
        category: 'Announcements',
        isExternal: false,
        description: 'HopeAI collaborates with Mayo Clinic Platform Accelerate to validate AI-driven trial solutions.'
    }
];

/**
 * Returns the latest N articles
 */
export function getLatestNews(count: number = 3): NewsItem[] {
    return newsList.slice(0, count);
}

/**
 * Returns the 3 closest adjacent articles in chronological order
 */
export function getAdjacentNews(currentSlug: string, count: number = 3): NewsItem[] {
    const total = newsList.length;
    if (total <= 1) return [];

    const normalizedSlug = currentSlug.replace(/^\/news\//, '').replace(/\/$/, '').toLowerCase();
    
    let index = newsList.findIndex(item => item.slug.toLowerCase() === normalizedSlug);
    if (index === -1) {
        index = newsList.findIndex(item => 
            item.slug.toLowerCase().includes(normalizedSlug) || 
            normalizedSlug.includes(item.slug.toLowerCase())
        );
    }

    if (index === -1) {
        return newsList.slice(0, count);
    }

    // Collect candidates with distance
    const candidates = [];
    for (let i = 0; i < total; i++) {
        if (i !== index) {
            candidates.push({ item: newsList[i], dist: Math.abs(i - index), index: i });
        }
    }

    // Sort primarily by distance. For ties, prefer newer (smaller index)
    candidates.sort((a, b) => {
        if (a.dist !== b.dist) return a.dist - b.dist;
        return a.index - b.index;
    });

    const selected = candidates.slice(0, count);
    // Sort in original chronological order
    selected.sort((a, b) => a.index - b.index);

    return selected.map(c => c.item);
}
